var _ellipse, _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _mask, _path9, _path10, _path11, _path12, _path13, _path14, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 113,
    viewBox: "0 0 164 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.05,
    cx: 78.076,
    cy: 49.7488,
    rx: 78.076,
    ry: 49.7488,
    transform: "matrix(-0.915086 -0.403258 -0.403298 0.915069 173.52 42.9695)",
    fill: "#72A4FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.1326 29.1311H115V89.0486C115 90.1532 114.105 91.0486 113 91.0486H72.1326C71.028 91.0486 70.1326 90.1532 70.1326 89.0486V29.1311Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5761_13016)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.7221,
    y: 65.9226,
    width: 37.6889,
    height: 21.5365,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.9721,
    y: 66.1726,
    width: 37.1889,
    height: 21.0365,
    rx: 0.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2264 70.4094V82.2235C78.2264 82.7757 78.6742 83.2235 79.2264 83.2235H87.7861M106.905 70.4094V82.2235C106.905 82.7757 106.458 83.2235 105.905 83.2235H97.3458M97.3458 83.2235H87.7861M97.3458 83.2235V70.4094M87.7861 83.2235V70.4094",
    stroke: "#E6E6E6",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2264 80.1726C79.2526 78.8775 82.342 76.1678 86.4899 75.6896C91.6748 75.0919 92.1609 77.4828 96.5356 77.4828C100.035 77.4828 104.907 74.3945 106.905 72.8503",
    stroke: "#5693FF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.906 72.24C107.412 72.24 107.822 72.6498 107.822 73.1553C107.822 73.6608 107.412 74.0706 106.906 74.0706C106.401 74.0706 105.991 73.6608 105.991 73.1553C105.991 72.6498 106.401 72.24 106.906 72.24Z",
    fill: "white",
    stroke: "#5693FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6841 74.9856C88.1897 74.9856 88.5994 75.3954 88.5994 75.9009C88.5994 76.4064 88.1897 76.8162 87.6841 76.8162C87.1786 76.8162 86.7688 76.4064 86.7688 75.9009C86.7688 75.3954 87.1786 74.9856 87.6841 74.9856Z",
    fill: "white",
    stroke: "#5693FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2268 79.5622C78.7324 79.5622 79.1421 79.972 79.1421 80.4775C79.1421 80.983 78.7324 81.3928 78.2268 81.3928C77.7214 81.3928 77.3116 80.983 77.3116 80.4775C77.3116 79.972 77.7214 79.5622 78.2268 79.5622Z",
    fill: "white",
    stroke: "#5693FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4481 76.8164C97.9537 76.8164 98.3634 77.2262 98.3634 77.7317C98.3634 78.2372 97.9537 78.647 97.4481 78.647C96.9426 78.647 96.5328 78.2372 96.5328 77.7317C96.5328 77.2262 96.9426 76.8164 97.4481 76.8164Z",
    fill: "white",
    stroke: "#5693FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5761_13016)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.7221,
    y: 32.72,
    width: 37.0499,
    height: 27.9933,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2221,
    y: 33.22,
    width: 36.0499,
    height: 26.9933,
    rx: 0.5,
    stroke: "#F2F2F2"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.616 56.0623C100.718 53.8115 103.031 47.8468 100.782 42.7398C98.5339 37.6327 92.5751 35.3173 87.4731 37.568C82.3714 39.8188 80.058 45.7835 82.3066 50.8905C84.5552 55.9976 90.514 58.313 95.616 56.0623Z",
    fill: "#C4D9FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7646 53.9929C98.7803 52.2214 100.601 47.5268 98.831 43.5073C97.0614 39.4877 92.3715 37.6653 88.3559 39.4367C84.3402 41.2082 82.5195 45.9028 84.2894 49.9224C86.0591 53.942 90.7489 55.7644 94.7646 53.9929Z",
    fill: "#F2F2F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8533 52.0107C96.7472 50.7341 98.0591 47.3512 96.7838 44.4546C95.5083 41.5581 92.1287 40.2448 89.2352 41.5214C86.3416 42.7979 85.0294 46.1809 86.3049 49.0774C87.5802 51.974 90.9598 53.2872 93.8533 52.0107Z",
    fill: "#C4D9FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0083 50.1054C94.8459 49.2947 95.6791 47.1463 94.8691 45.3067C94.0593 43.4672 91.9131 42.6331 90.0752 43.4438C88.2376 44.2546 87.4044 46.403 88.2141 48.2426C89.0241 50.0822 91.1704 50.9162 93.0083 50.1054Z",
    fill: "#F2F2F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.378 41.0452L106.941 42.0127L104.503 43.0858L102.94 42.1262L105.378 41.0452Z",
    fill: "#E6E6E6",
    stroke: "#E6E6E6",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.206 40.668L102.77 41.7402L103.117 39.9337L105.546 38.8612L105.206 40.668Z",
    fill: "#E6E6E6",
    stroke: "#E6E6E6",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1306 48.1551C92.9022 47.8147 93.2519 46.9126 92.9119 46.1402C92.5717 45.3678 91.6705 45.0176 90.8989 45.358C90.1273 45.6984 89.7773 46.6005 90.1176 47.3729C90.4575 48.1453 91.3587 48.4955 92.1306 48.1551Z",
    fill: "#C4D9FE"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-20-inside-1_5761_13016",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.4148 46.9369C91.3446 46.7659 91.4148 46.5648 91.5857 46.4944L105.849 40.2002C106.02 40.1298 106.221 40.2002 106.291 40.3711C106.361 40.542 106.291 40.7431 106.12 40.8135L91.8568 47.1078C91.686 47.1782 91.4951 47.0977 91.4148 46.9369Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4148 46.9369C91.3446 46.7659 91.4148 46.5648 91.5857 46.4944L105.849 40.2002C106.02 40.1298 106.221 40.2002 106.291 40.3711C106.361 40.542 106.291 40.7431 106.12 40.8135L91.8568 47.1078C91.686 47.1782 91.4951 47.0977 91.4148 46.9369Z",
    fill: "#CEC9C0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4148 46.9369L90.4898 47.3168L90.5037 47.3506L90.52 47.3833L91.4148 46.9369ZM91.5857 46.4944L91.9665 47.4191L91.978 47.4143L91.9894 47.4093L91.5857 46.4944ZM105.849 40.2002L105.468 39.2758L105.457 39.2804L105.446 39.2853L105.849 40.2002ZM106.291 40.3711L107.216 39.9911L107.216 39.9897L106.291 40.3711ZM106.12 40.8135L105.74 39.8889L105.728 39.8936L105.717 39.8986L106.12 40.8135ZM91.8568 47.1078L92.2378 48.0323L92.2493 48.0276L92.2606 48.0227L91.8568 47.1078ZM92.3398 46.5569C92.4526 46.8313 92.3688 47.2534 91.9665 47.4191L91.2048 45.5698C90.4609 45.8763 90.2367 46.7006 90.4898 47.3168L92.3398 46.5569ZM91.9894 47.4093L106.253 41.115L105.446 39.2853L91.182 45.5796L91.9894 47.4093ZM106.231 41.1245C105.953 41.2393 105.532 41.152 105.367 40.7524L107.216 39.9897C106.91 39.2483 106.087 39.0202 105.468 39.2758L106.231 41.1245ZM105.366 40.7511C105.254 40.4767 105.337 40.0546 105.74 39.8889L106.501 41.7381C107.245 41.4317 107.469 40.6073 107.216 39.9911L105.366 40.7511ZM105.717 39.8986L91.4531 46.1929L92.2606 48.0227L106.524 41.7284L105.717 39.8986ZM91.4758 46.1832C91.8224 46.0404 92.1718 46.2142 92.3096 46.4904L90.52 47.3833C90.8184 47.9813 91.5496 48.3159 92.2378 48.0323L91.4758 46.1832Z",
    fill: "#E6E6E6",
    mask: "url(#path-20-inside-1_5761_13016)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1326 23.9519C70.1326 22.8473 71.028 21.9519 72.1326 21.9519H113C114.105 21.9519 115 22.8473 115 23.9519V29.1307H70.1326V23.9519Z",
    fill: "#E2E2E2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7783 26.5777C74.3049 26.5777 74.7318 26.1508 74.7318 25.6243C74.7318 25.0977 74.3049 24.6709 73.7783 24.6709C73.2518 24.6709 72.825 25.0977 72.825 25.6243C72.825 26.1508 73.2518 26.5777 73.7783 26.5777Z",
    fill: "#FFA9A9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1159 26.5506C77.6425 26.5506 78.0692 26.1237 78.0692 25.5972C78.0692 25.0706 77.6425 24.6438 77.1159 24.6438C76.5894 24.6438 76.1624 25.0706 76.1624 25.5972C76.1624 26.1237 76.5894 26.5506 77.1159 26.5506Z",
    fill: "#FFD08A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.453 26.5777C80.9795 26.5777 81.4065 26.1508 81.4065 25.6243C81.4065 25.0977 80.9795 24.6709 80.453 24.6709C79.9264 24.6709 79.4997 25.0977 79.4997 25.6243C79.4997 26.1508 79.9264 26.5777 80.453 26.5777Z",
    fill: "#BBEEB6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_5761_13016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6104 21.9517H105.247V98.1099C105.247 99.2144 104.351 100.11 103.247 100.11H50.6104C49.5058 100.11 48.6104 99.2144 48.6104 98.1099V21.9517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_5761_13016)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.1413,
    y: 68.3933,
    width: 47.5746,
    height: 27.1855,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.3913,
    y: 68.6433,
    width: 47.0746,
    height: 26.6855,
    rx: 0.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.327 73.3933V88.9998C58.327 89.552 58.7747 89.9998 59.327 89.9998H70.7159M95.4938 73.3933V88.9998C95.4938 89.552 95.0461 89.9998 94.4938 89.9998H83.1048M83.1048 89.9998H70.7159M83.1048 89.9998V73.3933M70.7159 89.9998V73.3933",
    stroke: "#E6E6E6",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.327 86.046C59.6569 84.3676 63.6605 80.8559 69.036 80.2362C75.7555 79.4616 76.3854 82.5601 82.0549 82.5601C86.5905 82.5601 92.904 78.5578 95.4938 76.5566",
    stroke: "#5693FF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4949 75.7658C96.1501 75.7658 96.6811 76.2969 96.6811 76.952C96.6811 77.6071 96.1501 78.1382 95.4949 78.1382C94.8398 78.1382 94.3087 77.6071 94.3087 76.952C94.3087 76.2969 94.8398 75.7658 95.4949 75.7658Z",
    fill: "white",
    stroke: "#5693FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5838 79.3239C71.2389 79.3239 71.7699 79.855 71.7699 80.5101C71.7699 81.1652 71.2389 81.6963 70.5838 81.6963C69.9287 81.6963 69.3976 81.1652 69.3976 80.5101C69.3976 79.855 69.9287 79.3239 70.5838 79.3239Z",
    fill: "white",
    stroke: "#5693FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3275 85.2551C58.9827 85.2551 59.5137 85.7862 59.5137 86.4413C59.5137 87.0964 58.9827 87.6274 58.3275 87.6274C57.6724 87.6274 57.1413 87.0964 57.1413 86.4413C57.1413 85.7862 57.6724 85.2551 58.3275 85.2551Z",
    fill: "white",
    stroke: "#5693FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2375 81.6963C83.8926 81.6963 84.4236 82.2273 84.4236 82.8824C84.4236 83.5375 83.8926 84.0686 83.2375 84.0686C82.5824 84.0686 82.0513 83.5375 82.0513 82.8824C82.0513 82.2273 82.5824 81.6963 83.2375 81.6963Z",
    fill: "white",
    stroke: "#5693FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_5761_13016)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.141,
    y: 26.4822,
    width: 46.768,
    height: 35.3358,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.641,
    y: 26.9822,
    width: 45.768,
    height: 34.3358,
    rx: 0.5,
    stroke: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.7775 55.9466C87.2178 53.1055 90.1376 45.5763 87.2992 39.1297C84.4608 32.6831 76.9391 29.7603 70.4988 32.6014C64.0589 35.4425 61.1388 42.9717 63.9772 49.4183C66.8156 55.8649 74.3373 58.7877 80.7775 55.9466Z",
    fill: "#C4D9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7034 53.3348C84.7724 51.0987 87.0706 45.1727 84.8364 40.0988C82.6026 35.0249 76.6826 32.7245 71.6136 34.9606C66.5447 37.1968 64.2464 43.1227 66.4806 48.1966C68.7144 53.2705 74.6344 55.5709 79.7034 53.3348Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5523 50.8324C82.2051 49.221 83.8611 44.9507 82.2514 41.2945C80.6414 37.6382 76.3752 35.9804 72.7227 37.5918C69.0703 39.2032 67.4139 43.4735 69.0239 47.1298C70.6336 50.786 74.8998 52.4438 78.5523 50.8324Z",
    fill: "#C4D9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4856 48.4267C79.8052 47.4034 80.857 44.6914 79.8345 42.3693C78.8124 40.0473 76.1031 38.9944 73.7832 40.0178C71.4636 41.0412 70.4118 43.7532 71.434 46.0753C72.4564 48.3974 75.1657 49.4501 77.4856 48.4267Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.105 36.9168L95.2137 38.2219L91.9898 39.6404L89.882 38.3459L93.105 36.9168Z",
    fill: "#E6E6E6",
    stroke: "#E6E6E6",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9418 36.5606L89.7202 37.9782L90.1887 35.5414L93.4002 34.1234L92.9418 36.5606Z",
    fill: "#E6E6E6",
    stroke: "#E6E6E6",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3778 45.9654C77.3518 45.5357 77.7932 44.397 77.3641 43.422C76.9346 42.447 75.7971 42.0049 74.8231 42.4346C73.8491 42.8643 73.4073 44.003 73.8368 44.978C74.2659 45.9531 75.4034 46.3951 76.3778 45.9654Z",
    fill: "#C4D9FE"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-44-inside-2_5761_13016",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.4743 44.4278C75.3856 44.212 75.4743 43.9581 75.6899 43.8693L93.6947 35.9241C93.91 35.8352 94.1636 35.9241 94.2527 36.1398C94.3413 36.3556 94.2527 36.6094 94.037 36.6983L76.0322 44.6435C75.8165 44.7324 75.5756 44.6308 75.4743 44.4278Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.4743 44.4278C75.3856 44.212 75.4743 43.9581 75.6899 43.8693L93.6947 35.9241C93.91 35.8352 94.1636 35.9241 94.2527 36.1398C94.3413 36.3556 94.2527 36.6094 94.037 36.6983L76.0322 44.6435C75.8165 44.7324 75.5756 44.6308 75.4743 44.4278Z",
    fill: "#CEC9C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4743 44.4278L74.5493 44.8077L74.5631 44.8415L74.5794 44.8742L75.4743 44.4278ZM75.6899 43.8693L76.0708 44.7939L76.0823 44.7892L76.0936 44.7842L75.6899 43.8693ZM93.6947 35.9241L93.3132 34.9997L93.302 35.0043L93.291 35.0092L93.6947 35.9241ZM94.2527 36.1398L95.1776 35.7598L95.1771 35.7584L94.2527 36.1398ZM94.037 36.6983L93.6562 35.7736L93.6447 35.7784L93.6333 35.7834L94.037 36.6983ZM76.0322 44.6435L76.4132 45.5681L76.4246 45.5634L76.4359 45.5584L76.0322 44.6435ZM76.3992 44.0478C76.4935 44.2773 76.4282 44.6467 76.0708 44.7939L75.309 42.9447C74.5203 43.2696 74.2777 44.1466 74.5493 44.8077L76.3992 44.0478ZM76.0936 44.7842L94.0985 36.8389L93.291 35.0092L75.2862 42.9544L76.0936 44.7842ZM94.0763 36.8484C93.843 36.9447 93.4746 36.8759 93.3282 36.5212L95.1771 35.7584C94.8527 34.9722 93.9771 34.7257 93.3132 34.9997L94.0763 36.8484ZM93.3277 36.5198C93.2334 36.2903 93.2986 35.9209 93.6562 35.7736L94.4179 37.6229C95.2067 37.298 95.4492 36.4209 95.1776 35.7598L93.3277 36.5198ZM93.6333 35.7834L75.6285 43.7286L76.4359 45.5584L94.4407 37.6131L93.6333 35.7834ZM75.6512 43.7189C75.9529 43.5946 76.2523 43.7472 76.3691 43.9813L74.5794 44.8742C74.8988 45.5144 75.6802 45.8701 76.4132 45.5681L75.6512 43.7189Z",
    fill: "#E6E6E6",
    mask: "url(#path-44-inside-2_5761_13016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6104 14.8899C48.6104 13.7853 49.5058 12.8899 50.6104 12.8899H103.247C104.351 12.8899 105.247 13.7853 105.247 14.8899V21.9517H48.6104V14.8899Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2119 18.7292C53.8766 18.7292 54.4156 18.1904 54.4156 17.5257C54.4156 16.8611 53.8766 16.3223 53.2119 16.3223C52.5472 16.3223 52.0086 16.8611 52.0086 17.5257C52.0086 18.1904 52.5472 18.7292 53.2119 18.7292Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4257 18.6948C58.0904 18.6948 58.629 18.156 58.629 17.4913C58.629 16.8266 58.0904 16.2878 57.4257 16.2878C56.761 16.2878 56.222 16.8266 56.222 17.4913C56.222 18.156 56.761 18.6948 57.4257 18.6948Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6377 18.7292C62.3024 18.7292 62.8413 18.1904 62.8413 17.5257C62.8413 16.8611 62.3024 16.3223 61.6377 16.3223C60.973 16.3223 60.4344 16.8611 60.4344 17.5257C60.4344 18.1904 60.973 18.7292 61.6377 18.7292Z",
    fill: "#C6C6C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5761_13016",
    x: 69.7221,
    y: 65.9226,
    width: 45.6889,
    height: 29.5366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5761_13016"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5761_13016",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5761_13016",
    x: 69.7221,
    y: 32.72,
    width: 45.05,
    height: 35.9934,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5761_13016"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5761_13016",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_5761_13016",
    x: 44.6104,
    y: 8.88989,
    width: 68.6364,
    height: 99.22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5761_13016"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.794444 0 0 0 0 0.794444 0 0 0 0 0.794444 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5761_13016",
    result: "effect2_dropShadow_5761_13016"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5761_13016",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_5761_13016",
    x: 49.1413,
    y: 68.3933,
    width: 55.5746,
    height: 35.1855,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5761_13016"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5761_13016",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_5761_13016",
    x: 49.141,
    y: 26.4822,
    width: 54.768,
    height: 43.3357,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5761_13016"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5761_13016",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.f66863c8.svg";
export { ForwardRef as ReactComponent };